export class LanguageCodes {
    public static IT = "it";
    public static EN = "en";
}